import { Link, Text } from '@ltvco/refresh-lib/theme';

import { constants } from 'appConstants';

import { ChatTermsContainer } from './components';

interface ChatTermsProps {
  isAnimating?: boolean;
  animationPhase?: 'center' | 'moving-up' | 'moving-left' | 'header';
  isLanding?: boolean;
}

export const ChatTerms = ({
  isAnimating = false,
  animationPhase = 'center',
  isLanding = true,
}: ChatTermsProps) => {
  return (
    <ChatTermsContainer
      data-terms-element
      paddingBottom="20px"
      isAnimating={isAnimating}
      animationPhase={animationPhase}
      isLanding={isLanding}
    >
      <Text fontSize="0.813rem" color="text.secondary" textAlign="start">
        This chat feature is powered by artificial intelligence. BeenVerified is
        not responsible for any decisions, actions, or outcomes based on the
        information provided by the AI. The information provided or contained in
        any report and on our website is not necessarily 100% accurate, complete
        or up to date, nor a substitute for your own due diligence, especially
        concerning such sensitive items as criminal history, relatives,
        mortgages and liens. Our data comes from a wide variety of sources, but
        some municipalities and jurisdictions are slow to report and digitize
        their data, so we cannot guarantee or warrant full accuracy of ALL
        search results.
      </Text>
      <Text fontSize="0.813rem" color="text.secondary" textAlign="start">
        BeenVerified's mission is to give people easy and affordable access to
        public record information, but BeenVerified does not provide private
        investigator services or consumer reports, and is not a consumer
        reporting agency per the{' '}
        <Link
          href={constants.links.fcraLink}
          target="_blank"
          rel="noopener noreferrer"
          color="text.secondary"
          fontWeight="bold"
        >
          Fair Credit Reporting Act
        </Link>{' '}
        . You may not use our site or service or the information provided to
        make decisions about employment, admission, consumer credit, insurance,
        tenant screening or any other purpose that would require FCRA
        compliance. For more information governing permitted and prohibited
        uses, please review our{' '}
        <Link
          href={constants.links.doDontsLink}
          target="_blank"
          rel="noopener noreferrer"
          color="text.secondary"
          fontWeight="bold"
        >
          "Do's & Don'ts"
        </Link>{' '}
        and our{' '}
        <Link
          href={constants.links.tosLink}
          target="_blank"
          rel="noopener noreferrer"
          color="text.secondary"
          fontWeight="bold"
        >
          Terms & Conditions
        </Link>{' '}
        .
      </Text>
    </ChatTermsContainer>
  );
};
